import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { environment } from '../../Environment/environment';
import { saveAs } from 'file-saver';
@Injectable({
  providedIn: 'root'
})
export class NemaService {
  basePath: any;
  constructor(private http: HttpClient) { 
    this.basePath = environment.apiUrl;
  }

  public getInputSpeed():Observable<any>{
    return this.http.get<any[]>(this.basePath + 'Home/InputSpeed');
  }
  public getInputRatio():Observable<any>{
    return this.http.get<any[]>(this.basePath + 'Home/InputRatio');
  }
  public getReducer(reducer: JSON):Observable<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.basePath + 'Home/GetReducer', reducer, {
      headers,
      observe: 'response', // Add this line to observe the full response
      responseType: 'json', // Specify the response type as text
    });
  }
  public setDataAnalytics(product: string, clickType: string):Observable<any>{
    const url = `${this.basePath}Home/SetDataAnalytics?product=${product}&clickType=${clickType}`;
    return this.http.get<any[]>(url).pipe();
      // map((response: any) => response.value) // Extract and return the 'value' array
    // );
  }
  
  public getHpSpecification(request: any): Observable<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.basePath + 'HP/GetSpecification', request, {
      headers,
      observe: 'response',
      responseType: 'json',
    });
  }
  public getHpFanSpecification(request: any): Observable<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.basePath + 'HP/GetSpecification', request, {
      headers,
      observe: 'response',
      responseType: 'json',
    });
  }

  public getHpLargerReducer(request: any): Observable<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.basePath + 'HP/GetLargerReducer', request, {
      headers,
      observe: 'response',
      responseType: 'json',
    });
  }
  public getHpSmallerReducer(request: any): Observable<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.basePath + 'HP/GetSmallerReducer', request, {
      headers,
      observe: 'response',
      responseType: 'json',
    });
  }
  public getGearOrientation(size:any):Observable<any>{
    const url = `${this.basePath}HP/GetOrientation?size=${size}`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.value) // Extract and return the 'value' array
    );
  }
  public getShaftType(size:any):Observable<any>{
    const url = `${this.basePath}HP/GetShaftType?size=${size}`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.value) // Extract and return the 'value' array
    );
  }
  public getBoreDia(size:any):Observable<any>{
    const url = `${this.basePath}HP/GetBoreDiameter?size=${size}`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.value) // Extract and return the 'value' array
    );
  }
  
  public getHandAssembly(shaftType:any,gearOrientation:any,size:any):Observable<any>{
    const url = `${this.basePath}HP/GetHandAssembly?shaftType=${shaftType}&GearOrientation=${gearOrientation}&size=${size}`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.value) // Extract and return the 'value' array
    );
  }
  public getMountPosition(shaftType:any,gearOrientation:any,size:any,assembly:any):Observable<any>{
    const url = `${this.basePath}HP/GetMountPosition?shaftType=${shaftType}&GearOrientation=${gearOrientation}&size=${size}&assembly=${assembly}`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.value) // Extract and return the 'value' array
    );
  }
  public getCoolingFan(assembly:any,shaftType:any,gearOrientation:any,size:any):Observable<any>{
   
    const url = `${this.basePath}HP/GetCoolingFan?assembly=${assembly}&shaftType=${shaftType}&GearOrientation=${gearOrientation}&size=${size}`;
    return this.http.get<any[]>(url).pipe(map((response: any) => response.value));
  }
  public getMotorAdaptor():Observable<any>{
    const url = `${this.basePath}HP/GetMotorAdaptor`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.value) // Extract and return the 'value' array
    );
  }
  
  public getMotorFrameSize(size:any):Observable<any>{
    const url = `${this.basePath}HP/GetMotorFrameSize?size=${size}`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.value) // Extract and return the 'value' array
    );
  }
  public GenerateCADLoadbalancing(request:{
    Website:string,
    Guid:string,
    Code:string,
    asmFormat:string,
    dwgFormat:string,
    MotorFrame:string,
    FlangType:string,
    ShaftDia:string,
    TimeIn:string,
    ClientIP:string
}){
   
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.http.post(this.basePath+'/HP/CreateCAD',request,{headers,responseType:"text"}).subscribe((res)=>{alert("Data Passed for CAD");});
}
}
